import Vue from 'vue';
import transferTransformer from './../../transformers/transfer';
import store from '../../store';

const success = ({ data }, resolve) => {
  const transfer = transferTransformer.fetch(data);
  resolve(transfer);
  store.dispatch('fetchCurrentTransfer', transfer);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/transfers/${id}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/transfer/show.js